export const mapAgeAndBeddingFn = (childrenTiers, kidTiersOptions) => {
  if (!Array.isArray(kidTiersOptions) || kidTiersOptions.length === 0) return [];

  const codeCountMap = new Map();

  for (const child of childrenTiers) {
    const matchedTier = kidTiersOptions.find(
      (k) =>
        k.bedding === child.bed &&
        k.min_age <= child.age &&
        k.max_age >= child.age
    );

    if (!matchedTier) continue;

    const prevCount = codeCountMap.get(matchedTier.code) || 0;
    codeCountMap.set(matchedTier.code, prevCount + 1);
  }

  return Array.from(codeCountMap, ([code, count]) => ({ code, count }));
};

export const getTriplaLang = (lang) => {
  switch (lang) {
    case "en":
      return "en";
    case "ja":
      return "ja";
    case "ko":
      return "ko";
    case "zh-Hant":
      return "zh_Hant";
    case "zh-Hans":
      return "zh_Hans";
    case "zh_Hant":
      return "zh_Hant";
    case "zh_Hans":
      return "zh_Hans";
    default:
      return "ja";
  }
};
